import * as React from 'react';
import { ToastService } from '@mitchell/react.component.ux';
import { TranslationService } from "../../../common";
import { IntelligentAssignmentSummary } from '../../constants';
import { getDefaultToastMessage } from '../../utilities';
export const IntelligentAssignmentSummaryToastComponent = ({ toastNotification, onResetToast }) => {
    const toaster = React.useMemo(() => new ToastService(), []);
    const translateFn = TranslationService.translate;
    React.useEffect(() => {
        var _a;
        if (!(toastNotification === null || toastNotification === void 0 ? void 0 : toastNotification.operationType)) {
            return;
        }
        const message = toastNotification.customMessage || getDefaultToastMessage(toastNotification.operationType);
        if (!message) {
            return;
        }
        toaster.showToast({
            delay: IntelligentAssignmentSummary.TOAST_DELAY,
            open: true,
            type: (_a = toastNotification.toastType) !== null && _a !== void 0 ? _a : "Success" /* ToastType.Success */,
            message: translateFn(message),
            showCloseButton: true
        }, undefined);
        onResetToast();
    }, [toastNotification, toaster, onResetToast]);
    return null;
};
//# sourceMappingURL=IntelligentAssignmentSummaryToastComponent.js.map